import { BusinessRelationType } from '~/types/api/contacts/contact-summary';
import { grantsPortalAccess } from '~/utils/contact-portal-access';
const NO_ASSOCIATED_CUSTOMERS = [];
export const associatedCustomersOf = (contact)=>{
    var _contact_associatedCustomers;
    return (_contact_associatedCustomers = contact.associatedCustomers) !== null && _contact_associatedCustomers !== void 0 ? _contact_associatedCustomers : NO_ASSOCIATED_CUSTOMERS;
};
export const nativeUserIdOf = (contact)=>contact.relation.type === BusinessRelationType.Native ? contact.relation.native.userId : null;
export const hasPortalAccessAtCustomer = (customer)=>grantsPortalAccess(customer.businessRelation === BusinessRelationType.Native, customer.role);
export const isUnassociatedContact = (contact)=>associatedCustomersOf(contact).length === 0;
// WHY: deleting is permanent, so an absent list means "unknown", never "no clients to lose"
export const canDeleteContact = (contact)=>contact.associatedCustomers != null && contact.associatedCustomers.length === 0;
export const contactFullName = (contact)=>"".concat(contact.firstName, " ").concat(contact.lastName).trim();
